"use strict";

exports.__esModule = true;
exports.arrayify = void 0;
exports.debounce = debounce;
exports.pad = exports.int = void 0;
var pad = exports.pad = function pad(number, length) {
  if (length === void 0) {
    length = 2;
  }
  return ("000" + number).slice(length * -1);
};
var int = exports.int = function int(bool) {
  return bool === true ? 1 : 0;
};
function debounce(fn, wait) {
  var t;
  return function () {
    var _this = this;
    var args = arguments;
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
}
var arrayify = exports.arrayify = function arrayify(obj) {
  return obj instanceof Array ? obj : [obj];
};